import { WayflyerSchemas } from "api-types";

export const DEFAULT_MEMBER_ROLE: WayflyerSchemas.CompanyRole = "admin";

export const companyRoleLabels: Record<WayflyerSchemas.CompanyRole, string> = {
  admin: "Admin",
  financial_assistant: "Financial Assistant",
  user: "User",
};

export const companyRoleOptions = [
  { id: "admin", text: companyRoleLabels["admin"] },
  { id: "financial_assistant", text: companyRoleLabels["financial_assistant"] },
  { id: "user", text: companyRoleLabels["user"] },
];

const USER_PERMISSIONS = ["Manage funding applications", "Connect integrations"];
const FINANCIAL_ASSISTANT_PERMISSIONS = [...USER_PERMISSIONS, "Manage bank accounts", "View and make payments"];
const ADMIN_PERMISSIONS = [...FINANCIAL_ASSISTANT_PERMISSIONS, "Edit team members' roles"];

export const companyRolePermissionsMap: Record<WayflyerSchemas.CompanyRole, string[]> = {
  admin: ADMIN_PERMISSIONS,
  financial_assistant: FINANCIAL_ASSISTANT_PERMISSIONS,
  user: USER_PERMISSIONS,
};
